'use client';

import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';
import type { CardProps as MantineCardProps } from '@mantine/core';
import { Card as MantineCard } from '@mantine/core';

import type { LockedProps } from '../types';

// ScrollableCard is a bare, style-it-yourself scroll surface (its whole purpose):
// callers style the scroll container / apply animations, so `className` and `withBorder`
// stay open while the deeper overrides (classNames/style/…) remain locked.
type ScrollableCardProps = Omit<MantineCardProps, Exclude<LockedProps, 'className' | 'withBorder'>>;

export const ScrollableCard = forwardRef(
  (props: ScrollableCardProps, ref: ForwardedRef<HTMLDivElement>) => {
    return <MantineCard ref={ref} {...props} />;
  },
);

ScrollableCard.displayName = 'ScrollableCard';
